import QTable from 'quasar/src/components/table/QTable.js';

export function getVipGroupColumnsInAdmin(): QTable['columns'] {
  return [
    {
      name: 'title',
      field: 'title',
      label: 'عنوان',
      align: 'left',
      style: 'max-width:200px;'
    },
    {
      name: 'percent',
      field: 'percent',
      label: 'درصد تخفیف',
      align: 'center'
    },
    {
      name: 'users_count',
      field: 'users_count',
      label: 'تعداد کاربران',
      align: 'center'
    },
    {
      name: 'active',
      field: 'active',
      label: 'وضعیت',
      align: 'center'
    },
    {
      name: 'actions',
      field: 'actions',
      label: 'عملیات',
      align: 'center',
      style: 'max-width:50  px;'
    }]
}


